export default __webpack_public_path__ + "static/palettte4-ea0538ba6781218c93e394e099cf128e.jpg";